import { useFormContext, useWatch } from 'react-hook-form';

import { MAX_NUMBER_VALUE } from '@xemplo/gp-constants';
import { amendmentRateUnitFieldValidation } from '@xemplo/gp-utils';
import { NumberFieldRhf, NumberFormat } from '@xemplo/number-field';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

import { RecurringTypeValues } from './recurring-type';

export const RecurringMaxAmount = () => {
  const { control } = useFormContext<FormFields>();
  const recurringType = useWatch({ control, name: 'recurringType' });
  const showMaxAmount = recurringType === RecurringTypeValues.MAXIMUM_AMOUNT;

  if (!showMaxAmount) return null;
  return (
    <S.FormLabel>
      Maximum Amount
      <NumberFieldRhf
        placeholder="Enter maximum amount"
        name="recurringMaxAmount"
        aria-label="Recurring maximum amount field"
        step={0.01}
        formatOptions={{
          numberFormat: NumberFormat.Currency,
        }}
        rules={{
          required: 'This field is required',
          min: {
            value: 0,
            message: 'Field min value is 0',
          },
          max: {
            value: MAX_NUMBER_VALUE,
            message: `Field max value is ${MAX_NUMBER_VALUE}`,
          },
          deps: ['rate', 'units'],
          validate: (value, { rate, units }) =>
            amendmentRateUnitFieldValidation(
              rate,
              units,
              value,
              'The specified amount is lower than rate x units',
            ),
        }}
      />
    </S.FormLabel>
  );
};
